module.exports = __webpack_public_path__ + "img/back_active3.e908d9f2.png";